import { PageInfo, TableFetchData } from "@powerledger/ui-component-lib";
import { Dispatch, SetStateAction } from "react";

import { UseHasPermissions } from "@/app/hooks/use-has-permission";
import { ReturnTypeFormatAttributes } from "@/app/lib/format-attributes";
import { RECOrderAttributeOptions } from "@/app/lib/format-rec-options";
import {
  ERCOTUnSupportedColumns,
  MRETSUnSupportedColumns,
  UnSupportedColumns,
} from "@/app/lib/registry-attributes-helpers";
import { TraceXSupportedRegistries } from "@/app/types/okta.types";

import { ApplyFiltersFn } from "../../../components/page-header/filter/filter.types";
import { ErcotRecAttributes, Holding, MretsRecAttributes, RegistryCode } from "../../../types/generated/graphql";

/**
 * By default, attributes will accept both MretsRecAttributes and ErcotRecAttributes.
 * This can be restricted to a specific type (MretsRecAttributes) in contexts
 * like Forward REC assignment.
 */
export type RecHoldingsTableData<
  T extends MretsRecAttributes | ErcotRecAttributes = MretsRecAttributes | ErcotRecAttributes,
> = ReturnTypeFormatAttributes & Omit<Holding, "attributes"> & { attributes: T; registryDisplayName?: string };

export type RecHoldingsViewProps = {
  pageTitle: string;
  recOptions?: RECOrderAttributeOptions;
  handleFiltersChange: ApplyFiltersFn;
  refetchHoldings: () => void;
  loading?: boolean;
  recHoldingsTableData?: RecHoldingsTableData[];
  setSelected: Dispatch<SetStateAction<string[]>>;
  selected: string[];
  onSell: () => void;
  onRetire: () => void;
  onExport: () => void;
  pageInfo: PageInfo;
  fetchData: TableFetchData<RecHoldingsTableData>;
  hasPermissions: ReturnType<UseHasPermissions>["hasPermissions"];
  registryCode: TraceXSupportedRegistries;
  holdingsHiddenColumn: string[];
};

export const RECsHoldingsUnSupportedColumns: UnSupportedColumns = {
  [RegistryCode.Mrets]: {
    unsupportedColumns: [...MRETSUnSupportedColumns],
    toggleColumns: [],
  },
  [RegistryCode.Ercot]: {
    unsupportedColumns: [...ERCOTUnSupportedColumns],
    toggleColumns: [],
  },
};
